import Vue from 'vue'

export default {
    computed: {
        // Fixed v-on="$listeners" to work in combination with v-model
        // see: https://github.com/vuejs/vue/issues/6846#issuecomment-339665335
    	model: {
            get() {
                return this.value
            },
            set(value) {
                Vue.nextTick(() => {
                    this.$emit('input', value)
                })
            }
        },
        inputListeners() {
            let eventTransform = function (event) {
                // https://github.com/vuejs/vue/issues/7042

                // I don't know a better way to fix this
                let value = event

                if( typeOf(value).toLowerCase().indexOf('event') !== -1 ) { // this is because IE doesn't support InputEvent
                    value = event.target.value
                }

                this.$emit(event.type, value, event)
            }.bind(this)

            return Object.assign(
                {},
                // We add all the listeners from the parent
                this.$listeners,
                // Then we can add custom listeners or override the
                // behavior of some listeners.
                {
                    // This ensures that the component works with v-model
                    'input-debounced': eventTransform,
                    'input': eventTransform,
                    'change': eventTransform
                }
            )
        }
    }
}
